import type { TagProps } from '@dostavkee/web-ui'

import {
    DomainRecruiterNewDriverStatusEnum as RecruitmentConfirmStatus,
    V1RequestStateStringEnum as RequestStatus,
} from '@/shared/api'
import { LIMIT_OPTIONS } from '@/shared/model'

export const PAGE_SIZE = LIMIT_OPTIONS[0]

export const RECRUITMENT_CONFIRM_STATUS_TO_TEXT: Record<RecruitmentConfirmStatus, string> = {
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusNew]: 'Создано',
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusNotified]: 'Отправлено',
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusConfirmed]: 'Подтверждено',
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusDeclined]: 'Отклонено',
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusCanceled]: 'Отменено',
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusError]: 'Ошибка',
}

export enum RECRUITMENT_STATUS_ENUM {
    'needAction' = 'needAction',
    'inProgress' = 'inProgress',
    'connected' = 'connected',
    'declined' = 'declined',
    'error' = 'error',
}

export const RECRUITMENT_STATUS_TO_TEXT: Record<RECRUITMENT_STATUS_ENUM, string> = {
    [RECRUITMENT_STATUS_ENUM.needAction]: 'Нужно действие',
    [RECRUITMENT_STATUS_ENUM.inProgress]: 'В работе',
    [RECRUITMENT_STATUS_ENUM.connected]: 'Подключён',
    [RECRUITMENT_STATUS_ENUM.declined]: 'Не подключён',
    [RECRUITMENT_STATUS_ENUM.error]: 'Ошибка',
}

export const RECRUITMENT_STATUS_TO_TAG_VARIANT: Record<
    RECRUITMENT_STATUS_ENUM,
    TagProps['variant']
> = {
    [RECRUITMENT_STATUS_ENUM.needAction]: 'warning',
    [RECRUITMENT_STATUS_ENUM.inProgress]: 'default',
    [RECRUITMENT_STATUS_ENUM.connected]: 'success',
    [RECRUITMENT_STATUS_ENUM.declined]: 'danger',
    [RECRUITMENT_STATUS_ENUM.error]: 'danger',
}

export const RECRUITMENT_STATUS_RULES: Record<
    RecruitmentConfirmStatus,
    Record<RequestStatus, RECRUITMENT_STATUS_ENUM>
> = {
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusConfirmed]: {
        [RequestStatus.requestStateAcceptString]: RECRUITMENT_STATUS_ENUM.connected,
        [RequestStatus.requestStateCheckinString]: RECRUITMENT_STATUS_ENUM.inProgress,
        [RequestStatus.requestStateIdleString]: RECRUITMENT_STATUS_ENUM.inProgress,
        [RequestStatus.requestStateDeclineString]: RECRUITMENT_STATUS_ENUM.needAction,
        [RequestStatus.requestStateUnknownString]: RECRUITMENT_STATUS_ENUM.error,
    },
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusDeclined]: {
        [RequestStatus.requestStateAcceptString]: RECRUITMENT_STATUS_ENUM.declined,
        [RequestStatus.requestStateCheckinString]: RECRUITMENT_STATUS_ENUM.declined,
        [RequestStatus.requestStateIdleString]: RECRUITMENT_STATUS_ENUM.declined,
        [RequestStatus.requestStateDeclineString]: RECRUITMENT_STATUS_ENUM.declined,
        [RequestStatus.requestStateUnknownString]: RECRUITMENT_STATUS_ENUM.error,
    },
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusNew]: {
        [RequestStatus.requestStateAcceptString]: RECRUITMENT_STATUS_ENUM.needAction,
        [RequestStatus.requestStateCheckinString]: RECRUITMENT_STATUS_ENUM.inProgress,
        [RequestStatus.requestStateIdleString]: RECRUITMENT_STATUS_ENUM.inProgress,
        [RequestStatus.requestStateDeclineString]: RECRUITMENT_STATUS_ENUM.needAction,
        [RequestStatus.requestStateUnknownString]: RECRUITMENT_STATUS_ENUM.error,
    },
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusNotified]: {
        [RequestStatus.requestStateAcceptString]: RECRUITMENT_STATUS_ENUM.needAction,
        [RequestStatus.requestStateCheckinString]: RECRUITMENT_STATUS_ENUM.inProgress,
        [RequestStatus.requestStateIdleString]: RECRUITMENT_STATUS_ENUM.inProgress,
        [RequestStatus.requestStateDeclineString]: RECRUITMENT_STATUS_ENUM.needAction,
        [RequestStatus.requestStateUnknownString]: RECRUITMENT_STATUS_ENUM.error,
    },
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusCanceled]: {
        [RequestStatus.requestStateAcceptString]: RECRUITMENT_STATUS_ENUM.declined,
        [RequestStatus.requestStateCheckinString]: RECRUITMENT_STATUS_ENUM.declined,
        [RequestStatus.requestStateIdleString]: RECRUITMENT_STATUS_ENUM.declined,
        [RequestStatus.requestStateDeclineString]: RECRUITMENT_STATUS_ENUM.declined,
        [RequestStatus.requestStateUnknownString]: RECRUITMENT_STATUS_ENUM.error,
    },
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusError]: {
        [RequestStatus.requestStateAcceptString]: RECRUITMENT_STATUS_ENUM.error,
        [RequestStatus.requestStateCheckinString]: RECRUITMENT_STATUS_ENUM.error,
        [RequestStatus.requestStateIdleString]: RECRUITMENT_STATUS_ENUM.error,
        [RequestStatus.requestStateDeclineString]: RECRUITMENT_STATUS_ENUM.error,
        [RequestStatus.requestStateUnknownString]: RECRUITMENT_STATUS_ENUM.error,
    },
}

export const RECRUITMENT_STATUS_RULES_WITHOUT_USER_REQUEST: Record<
    RecruitmentConfirmStatus,
    RECRUITMENT_STATUS_ENUM
> = {
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusConfirmed]: RECRUITMENT_STATUS_ENUM.connected,
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusDeclined]: RECRUITMENT_STATUS_ENUM.declined,
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusNew]: RECRUITMENT_STATUS_ENUM.needAction,
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusNotified]: RECRUITMENT_STATUS_ENUM.needAction,
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusCanceled]: RECRUITMENT_STATUS_ENUM.declined,
    [RecruitmentConfirmStatus.RecruiterNewDriverStatusError]: RECRUITMENT_STATUS_ENUM.error,
}
